import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeRoutingModule } from "./home-routing.module";
import { HomeComponent } from "./home.component";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { BarChartComponent } from "../../../components/charts/bar-chart/bar-chart.component";
import { PieChartComponent } from "../../../components/charts/pie-chart/pie-chart.component";
import { LineChartComponent } from "../../../components/charts/line-chart/line-chart.component";
import { ChartsModule } from "ng2-charts";
import { HomeService } from "../../../providers/home.service";
import { UsuarioService } from "../../../providers/usuario.service";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { DonaChartComponent } from "../../../components/charts/dona-chart/dona-chart.component";
import { PropuestasModule } from "../../../components/propuestas/propuestas.module";
import { DashboardModule } from "../../../components/dashboard/dashboard.module";
import { AgendaModule } from "../../../components/agenda/agenda.module";
import { HelpComponent } from "../../../components/help/help.component";



@NgModule({
    imports: [
        CommonModule,
        HomeRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        ChartsModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        PropuestasModule,
        DashboardModule,
        AgendaModule,
    ],
    declarations: [
        HomeComponent,
        BarChartComponent,
        PieChartComponent,
        LineChartComponent,
        DonaChartComponent,
        HelpComponent
    ],
    providers: [
        HomeService,
        UsuarioService
    ]
})
export class HomeModule { }